import React, { PureComponent } from 'react';
import { resultsExtraHelper, geoJSONMarkerHelper, featurePointConverterHelper } from '../../../helpers/mapboxhelpers';
import center from "@turf/center";
import flip from "@turf/flip";
import { point } from "@turf/helpers";
import _join from 'lodash/join';
import _forEach from 'lodash/forEach';
import _unionBy from 'lodash/unionBy';
import { replaceDashSpace } from '../../../helpers/stringutils';


let loadCityData = {};

///////////////////////
// Loading order
// 1. Load Coordinates points from SEQUENCE API
// 2. Initialise maps
// 3. Load map styles and waypoints
// 4. Draw line on map
// 5. Ready - draw markers and event listeners
///////////////////////
class MapBox extends PureComponent{

  constructor(props){
    super(props);
    this.state = {
      isClick:false,
      loadCityData:{},
      offset:null
    }
    this.onMapboxcavasClick = this.onMapboxcavasClick.bind(this);

    this.maps = {
      cyaoMap:null
    }

    this.mapDetails = {
      "zoom":3,
      "pitch":0,
      "bearing":0,
      "center":[4.21, 49.22],
      "centerMobile":[5.02, 48.49]
    }

  }

  

  componentDidMount(){

      this.intialiseMap();

      this.setState({offset:document.querySelector('.booking-hightlights').offsetWidth});
      
      if(this.props.clickable){
        this.myMap.addEventListener("click", this.onMapboxcavasClick, true);
      }
  }

  componentDidUpdate(prevProps, prevState) {

      const { countriesShow, clickable, isCollapse } = this.props;

      if(countriesShow !== prevProps.countriesShow){

          if(typeof countriesShow === 'object') this.loadMapData(countriesShow);
          
          if(clickable){
            this.myMap.addEventListener("click", this.onMapboxcavasClick, true);
          }
      }

      if(isCollapse !== prevProps.isCollapse){
        this.loadMapData(countriesShow);
      }
  }

  componentWillUnmount(){
    // cancelAnimationFrame(myReq);
    // myAnim = null;
    if(this.props.clickable){
      this.myMap.removeEventListener("click", this.onMapboxcavasClick, true);
    }
  }

  async loadMapData(data){

    const resultResponse = data;

    if(resultResponse.length !== 0){
      loadCityData.json = resultsExtraHelper(resultResponse);
      loadCityData.exampleCoordinatePoints = geoJSONMarkerHelper(loadCityData.json);
      loadCityData.coordinates = loadCityData.json.map(data => data.coordinates);      
      loadCityData.centerPoint = center(featurePointConverterHelper(loadCityData.coordinates));
      this.mapDetails.center = flip( point( loadCityData.centerPoint.geometry.coordinates )).geometry.coordinates;
    }
  
    //1.
    if(resultResponse.length > 1 && loadCityData.coordinates.length > 1){
    
      //2.
      const results = await this.loadMapWayPoints(loadCityData.coordinates);
      await this.mapDrawLine(results);
      await this.zoomToCenter();
      await this.ready();

    }else{
      
      if(this.maps.cyaoMap !== null){

        //Remove any lines or points
        const routeLayer = this.maps.cyaoMap.getLayer('route');
        if(typeof routeLayer !== 'undefined')  this.maps.cyaoMap.removeLayer('route').removeSource('route');
      }

      //Remove all pointer and city text instances 
      document.querySelectorAll('.circleoutline').forEach(element => { element.remove() });
      document.querySelectorAll('.city-text').forEach(element => { element.remove() });

    } 


  }

  async zoomToCenter(){

    const _coords = loadCityData.coordinates;
    const _bounds = _coords.reduce((bounds, coord) => {
          return bounds.extend(coord);
    }, new window.mapboxgl.LngLatBounds(_coords[0], _coords[0]));


    this.maps.cyaoMap.fitBounds(_bounds, {
      padding: 60, 
      offset: (this.props.isCollapse && window.innerWidth > 640) ? [-this.state.offset/4,0] : [0,0],
      maxZoom:5
    });

    //Remove all text
    document.querySelectorAll(".mapboxgl-canvas-container .city-text").forEach(element => {
      if(element.classList.contains('active')){ 
        element.classList.remove('active');
      }
    });

  }

  intialiseMap(){
  
    if(window.mapboxgl === undefined) return; 

    if (!window.mapboxgl.supported()) {
      alert('Your browser does not support Mapbox GL');
    } else {
      window.mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_API_TOKEN;

      this.maps.cyaoMap = new window.mapboxgl.Map({
        container: this.myMap,
        style: "mapbox://styles/ken-busabout/cjm91nhzo0cji2rnyd5jx50g4",
        bearing:this.mapDetails.bearing,
        pitch:this.mapDetails.pitch,
        zoom:this.mapDetails.zoom,
        center:this.props.destination === "usa" ? 
              (window.innerWidth > 640) ? [-103.71, 39.38] : [-103.71, 39.38] : 
              (window.innerWidth > 640) ? [4.21, 49.22] : [5.02, 48.49],
        attributionControl: false,
        hash:false,
        scrollZoom :false,
        interactive:false
      });

      this.maps.cyaoMap.on('load', () => {
        this.loadMapData(this.props.countriesShow);
      })

      
    }
  }

  async loadMapWayPoints(coordinates){

    if(coordinates.length > 25){

      let arr1 = coordinates.slice(0,24);
      let arr2 = coordinates.slice(24);
      
      const results1 = await this.loadDirections(arr1);
      const results2 = await this.loadDirections(arr2);

      return _unionBy(results1, results2);
      
    }else{
      return await this.loadDirections(coordinates);
    }

  }


  loadDirections(coordinates){
    
    var _coordinates = _join(coordinates, ';');

    var _url = "https://api.mapbox.com/directions/v5/mapbox/driving/" + _coordinates + ".json?access_token=" + process.env.REACT_APP_MAPBOX_API_TOKEN + "&overview=simplified&geometries=geojson&exclude=ferry";
      return new Promise((resolve, reject) => {
      fetch(_url)
      .then(response => response.json())
      .then((json) => {
          resolve(json.routes[0].geometry.coordinates);
      })
      .catch(e => {
        reject();
      })
    });
  }

  async mapDrawLine(coordinates){

    //Check and remove any layer and source
    try{
      const routeLayer = this.maps.cyaoMap.getLayer('route');
      if(typeof routeLayer !== 'undefined')  this.maps.cyaoMap.removeLayer('route').removeSource('route');
    }
    catch(e){}
    
    //Remove all pointer and city text instances 
    document.querySelectorAll('.circleoutline').forEach(element => { element.remove() });
    document.querySelectorAll('.city-text').forEach(element => { element.remove() });


    var route = {
      "type": "FeatureCollection",
      "features": [{
        "type": "Feature",
        "geometry": {
          "type": "LineString",
          "coordinates": coordinates
        }
      }]
    };

    try{
      this.maps.cyaoMap.addSource('route', {"type": "geojson", "data": route});
      this.maps.cyaoMap.addLayer({
        "id": "route",
        "source": "route",
        "type": "line",
        "paint": {
          "line-width": 2,
          "line-color": "#ff6700"
        }
      });
    }
    catch(e){}
  }

  async ready(){

    const featureArr = loadCityData.exampleCoordinatePoints.features;


    const svgIcon = '<svg xmlns="http://www.w3.org/2000/svg" class="flag-icon" viewBox="0 0 53.827 53.827">' +
          '<path d="M12.519 39.825v9.042a3.959 3.959 0 0 1-3.959 3.959h-.72a3.959 3.959 0 0 1-3.959-3.959V13.959a7.2 7.2 0 1 1 10.822-8.857 21.82 21.82 0 0 1 4.7-.5 27.128 27.128 0 0 1 9.055 1.7c1.886.6 1.923.614 2.579.8a13.842 13.842 0 0 0 3.826.624c3.079 0 6.537-1.072 10.8-3.053a5.038 5.038 0 0 1 7.162 4.569v23.537a5.035 5.035 0 0 1-2.212 4.173 22.859 22.859 0 0 1-13.31 4.358 27.128 27.128 0 0 1-9.055-1.7c-1.886-.6-1.923-.614-2.579-.8a13.842 13.842 0 0 0-3.826-.624 24.3 24.3 0 0 0-9.324 1.639zM8.203 9.28a1.08 1.08 0 1 0-1.082-1.078A1.078 1.078 0 0 0 8.203 9.28z" fill="#ff5a00" stroke="#fff" stroke-width="2"/>'+
        '</svg>';



    //add product markers to map
    _forEach(featureArr, (marker, index) => {

        //create dom element for marker
        var pointElement = document.createElement('div');
        pointElement.className = "point " +  marker.properties.pointClass;
        pointElement.className += (index === 0) ? ' start-end' : '';
        pointElement.innerHTML += marker.properties.duration;
        pointElement.innerHTML += (index === 0) ? svgIcon : "";
        if(this.props.clickable){
          pointElement.className += (index === 0) ? ' active start-end' : '';
          pointElement.className += (index === featureArr.length - 1) ? 'start-end' : '';
          pointElement.setAttribute('data-index', index);
          pointElement.setAttribute('data-city', marker.properties.name );
          pointElement.addEventListener('click', () => this.markersClicked(index, marker.geometry.coordinates, marker.properties.name, marker.properties.id) );
          pointElement.addEventListener('mouseenter', () => this.markerMouseOver(marker.properties.name) );
          pointElement.addEventListener('mouseleave', () => this.markerMouseOut(marker.properties.name));
        }


        var pointText = document.createElement('div');
        pointText.className = marker.properties.textClass;
        pointText.innerHTML += replaceDashSpace(marker.properties.name);
        pointText.setAttribute('data-city',  marker.properties.name + '-text');


        //pass elements to marker - offset product
        if(pointElement.classList.contains('product')){
          new window.mapboxgl.Marker(pointElement, {offset: [30, 0]}).setLngLat(marker.geometry.coordinates).addTo(this.maps.cyaoMap);
          new window.mapboxgl.Marker(pointText, {offset: [30,0]}).setLngLat(marker.geometry.coordinates).addTo(this.maps.cyaoMap);
        }else{
          new window.mapboxgl.Marker(pointElement, {offset: [0, 0]}).setLngLat(marker.geometry.coordinates).addTo(this.maps.cyaoMap);
          new window.mapboxgl.Marker(pointText, {offset: [0,0]}).setLngLat(marker.geometry.coordinates).addTo(this.maps.cyaoMap);
        }

    });


  }

  markersClicked(index, coords, name, id){

    if(this.props.isItinerary){
      this.props.openPanel(id);
    }else{

      this.setState({isClick: true});

      //Pulse active marker
      document.querySelectorAll(".mapboxgl-canvas-container .point").forEach(element => {
        if(element.classList.contains('active')){
          element.classList.remove('active');
        }
      })

      document.querySelector("[data-index='" + index + "']").classList.add('active');

      //Zoom in and out
      if(this.state.isClick){
        this.maps.cyaoMap.flyTo({
          center:coords,
          zoom:5, 
          speed:2, 
          offset:(window.innerWidth > 640) ? [-this.state.offset/4,0] : [0,0]
        });
        this.markerMouseOver(name);
      }else{
        this.zoomToCenter();
      }

    }
  }

  markerMouseOver(name){
    document.querySelector("[data-city='" + name + "-text']").classList.add('active');
  }

  markerMouseOut(name){
    if(!this.state.isClick){
      document.querySelector("[data-city='" + name + "-text']").classList.remove('active');
    }
  }

  onMapboxcavasClick(){
    if(this.state.isClick){
      this.zoomToCenter();
      this.setState({isClick:false});
    }
  }

  render(){
      return(
        <div className="map-wrapper">
          <div ref={el => this.myMap = el } id={this.props.id}></div>
        </div>
      )
  }


}

export default MapBox;
